import { IS_APP } from "@/__main__/constants.mjs";
import globals from "@/util/global-whitelist.mjs";
import { normalizePathname } from "@/util/mod-pathname.mjs";
import { USE_META_AS_CTRL } from "@/util/use-hotkey.mjs";

/* ensure you do not capitalize anything, leave it all lowercase */
const KEY_LISTENERS = new Map([
  /* copy current path in clipboard */
  [
    ["control", "shift", "c"],
    () =>
      globals.navigator.clipboard.writeText(
        normalizePathname(globals.location.href),
      ),
  ],
]);

const PRESSED_KEYS = [];

function handleKeydownEvent(event) {
  const lowerCaseKey = event.key.toLowerCase();
  if (!PRESSED_KEYS.includes(lowerCaseKey)) PRESSED_KEYS.push(lowerCaseKey);

  Array.from(KEY_LISTENERS.keys()).forEach((_keys) => {
    const keys = (Array.isArray(_keys) ? _keys : [_keys]).map((key) => {
      return USE_META_AS_CTRL && key === "control" ? "meta" : key;
    });
    if (
      keys.every((key) => PRESSED_KEYS.includes(key)) &&
      keys.length === PRESSED_KEYS.length &&
      !event.repeat
    ) {
      KEY_LISTENERS.get(_keys)?.();
    }
  });
}

function handleKeyupEvent(event) {
  PRESSED_KEYS.splice(PRESSED_KEYS.indexOf(event.key.toLowerCase()), 1);
}

export function attachKeyListeners() {
  if (!IS_APP) return;
  globals.document.addEventListener("keydown", handleKeydownEvent);
  globals.document.addEventListener("keyup", handleKeyupEvent);
}

export function removeKeyListeners() {
  if (!IS_APP) return;
  globals.document?.removeEventListener("keydown", handleKeydownEvent);
  globals.document?.removeEventListener("keyup", handleKeyupEvent);
}
